module.exports = __webpack_public_path__ + "img/Order-Taking.4425f2b7.jpg";